<template>
	<div
		ref="listRef"
		class="relative flex items-center w-full min-h-[56px]"
		:class="[
			profileField == true
				? ''
				: 'md:w-[calc(20%-20px)] pl-0 sm:pl-4 md:pl-6 pr-0 sm:pr-4 pb-2 md:pb-0 mt-3 md:mt-0 border-b-[1px] border-gray-light md:border-0',
		]"
	>
		<div @click="showList = !showList" class="flex flex-col flex-1 w-[calc(100%-30px)] cursor-pointer">
			<span class="pb-1 text-dj-gray-dark text-sm font-medium">
				<template v-if="label && label.length > 0">{{ label }}</template>
				<template v-else>{{ $t("jobs.searchbar.category.title") }}</template>
			</span>
			<span
				v-if="selectedCategories && selectedCategories.length"
				class="block w-[calc(100%-6px)] whitespace-nowrap overflow-ellipsis overflow-hidden"
			>
				{{ selectedCategories.map((ele) => ele.name[locale]).join(", ") }}
			</span>
			<span v-else class="text-dj-gray">{{ placeholder }}</span>
		</div>

		<DropdownButton v-model="showList" class="mt-2" />

		<div
			v-if="showList"
			class="absolute flex-col sm:flex-row p-5 left-0 top-[60px] md:top-[85px] w-[740px] max-w-[100%] md:max-w-[100vw] h-[max-content] bg-white border border-dj-gray-light rounded-big flex z-30"
			:class="[profileField == true ? 'top-[70px] md:top-[85px] left-auto right-0 md:max-w-[100vw]' : '']"
		>
			<div
				class="flex flex-wrap gap-2 h-max w-full"
				:class="[subcategories && subcategories.length ? 'sm:w-1/2' : 'sm:w-full']"
			>
				<BaseTagPill
					@click="handleCategoryClick(category)"
					:type="category.value ? 'pink' : 'normal'"
					class="cursor-pointer"
					size="small"
					v-for="(category, index) in categories"
					:key="index"
				>
					{{ category.name[locale] }}
				</BaseTagPill>
			</div>
			<div v-if="subcategories && subcategories.length" class="flex flex-wrap w-full sm:w-1/2 mt-4 sm:mt-0">
				<div v-for="(item, index) in subcategories" :key="index">
					<span class="text-sm">{{ item.parent }}</span>
					<div class="flex flex-wrap gap-2 my-2">
						<BaseTagPill
							@click="handleSubcategoryClick(item.parent, subcategory)"
							:type="subcategory.value ? 'pink' : 'normal'"
							class="cursor-pointer"
							v-for="(subcategory, index) in item.subcategories"
							:key="index"
							size="small"
						>
							{{ subcategory.name[locale] }}
						</BaseTagPill>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
//*** USED FOR REGISTRATON PAGE ALSO */

import { defineComponent, type PropType, ref, computed, onMounted, watch } from "vue";
import { onClickOutside } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import axios from "axios";
import { type categoriesObject } from "~~/types";

export default defineComponent({
	name: "SearchbarJobsCategory",
	props: {
		modelValue: {
			type: Object as PropType<categoriesObject>,
			required: true,
		},
		placeholder: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: "",
		},
		profileField: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["update:modelValue", "loaded"],
	async setup(props, { emit }) {
		const { locale } = useI18n();

		onMounted(() => {
			let filterScope = props.profileField == false ? "&scope[]=hasAttachedJob" : "";

			if (globalConfig.isBlue) {
				filterScope = `${filterScope}&scope[]=isBlue`;
			}

			if (globalConfig.isNotBlueHU) {
				filterScope = `${filterScope}&scope[]=isNotBlue`;
			}

			axios(globalConfig.API + "/tags?type[]=job-category&limit=20000" + filterScope).then((response) => {
				categoriesData.value = response.data;
				addValuePropToCategories();

				if (props.profileField == false) {
					getValuesFromUrl();
				}
				if (props.profileField == true) {
					getValuesFromVModel();
				}

				emit("loaded");
			});
		});

		const categoriesData = ref();
		const route = useRoute();

		const showList = ref(false);
		const listRef = ref(null);

		const categories = ref([]);
		const subcategories = computed(() => {
			const subs = [];
			selectedCategories.value.forEach((category) => {
				subs.push({
					parent: category.name[locale.value],
					subcategories: category.children,
				});
			});
			return subs;
		});

		watch(
			() => props.modelValue,
			(value) => {
				if (value.categories.length == 0 && value.subcategories.length == 0) {
					clearSelectedValues();
				}
			}
		);

		// Check the url parameters and set value if given
		watch(
			() => route.query,
			(value) => {
				if (value && value.category != undefined) {
					addValuePropToCategories();
					getValuesFromUrl();
				}
			}
		);

		const selectedCategories = ref([]);
		const selectedSubcategories = ref([]);

		function clearSelectedValues() {
			selectedCategories.value = [];
			selectedSubcategories.value = [];
			categories.value.forEach((category) => {
				category.children.map((subcategory) => {
					subcategory.value = false;
				});
				category.value = false;
			});
		}

		function addValuePropToCategories() {
			if (categoriesData) {
				categories.value = categoriesData.value.data.map((category) => {
					category.children = category.children.map((subcategory) => {
						return {
							...subcategory,
							value: false,
						};
					});
					return {
						...category,
						value: false,
					};
				});
			}
		}

		function emitCategories() {
			const categoriesId = selectedCategories.value.map((category) => category.id);
			const subcategoriesId = selectedSubcategories.value.map((subcategory) => subcategory.id);
			emit("update:modelValue", { categories: categoriesId, subcategories: subcategoriesId });
		}

		function handleCategoryClick(category) {
			const index = categories.value.findIndex((pred) => pred.name[locale.value] == category.name[locale.value]);
			if ((categories.value[index].value = !categories.value[index].value)) {
				selectedCategories.value.push(category);
			} else {
				// remove subcategories of category from selectedSubcategories
				category.children.forEach((subcategory) => {
					selectedSubcategories.value = selectedSubcategories.value.filter(
						(sSubcategory) => sSubcategory.name[locale.value] != subcategory.name[locale.value]
					);
				});
				// remove category from selectedCategories
				selectedCategories.value = selectedCategories.value.filter(
					(pred) => pred.name[locale.value] != category.name[locale.value]
				);
			}
			emitCategories();
		}

		function handleSubcategoryClick(parent, subcategory) {
			// get index by parent name
			const parentIndex = subcategories.value.findIndex((pred) => pred.parent == parent);
			// get subcategory index
			const index = subcategories.value[parentIndex].subcategories.findIndex(
				(pred) => pred.name[locale.value] == subcategory.name[locale.value]
			);
			if (
				(subcategories.value[parentIndex].subcategories[index].value =
					!subcategories.value[parentIndex].subcategories[index].value)
			) {
				selectedSubcategories.value.push(subcategory);
			} else {
				selectedSubcategories.value = selectedSubcategories.value.filter(
					(pred) => pred.name[locale.value] != subcategory.name[locale.value]
				);
			}
			emitCategories();
		}

		function getValuesFromUrl() {
			// get params
			const query = route.query;

			if (query.category) {
				// get categories from URL
				const categoriesFromUrl = query.category
					.toString()
					.split(",")
					.map((c) => Number.parseInt(c));
				let subcategoriesFromUrl: number[];
				if (query.subcategory) {
					// get subcategories from URL
					subcategoriesFromUrl = query.subcategory
						.toString()
						.split(",")
						.map((c) => Number.parseInt(c));
				}
				categoriesFromUrl.forEach((categoryID) => {
					// get index by category's ID
					const index = categories.value.findIndex((pred) => pred.id == categoryID);
					// set category value
					categories.value[index].value = true;
					if (
						selectedCategories.value.filter((category) => category.id == categories.value[index].id)
							.length == 0
					) {
						selectedCategories.value.push(categories.value[index]);
					}

					if (query.subcategory) {
						subcategoriesFromUrl.forEach((subcategoryID) => {
							// get parent index by parent name
							const parentIndex = subcategories.value.findIndex(
								(pred) => pred.parent == categories.value[index].name[locale.value]
							);
							// get subcategory index by ID
							const subIndex = subcategories.value[parentIndex].subcategories.findIndex(
								(pred) => pred.id == subcategoryID
							);

							if (subIndex != -1) {
								// set subcategory value
								subcategories.value[parentIndex].subcategories[subIndex].value = true;
								// add to selected subcategories array
								selectedSubcategories.value.push(
									subcategories.value[parentIndex].subcategories[subIndex]
								);
							}
						});
					}
				});
				emitCategories();
			}
		}

		function getValuesFromVModel() {
			props.modelValue.categories.forEach((categoryID) => {
				// get index by category's ID
				const index = categories.value.findIndex((pred) => pred.id == categoryID);
				// set category value
				if (index > -1) {
					categories.value[index].value = true;

					if (
						selectedCategories.value.filter((category) => category.id == categories.value[index].id)
							.length == 0
					) {
						selectedCategories.value.push(categories.value[index]);
					}

					props.modelValue.subcategories.forEach((subcategoryID) => {
						// get parent index by parent name
						const parentIndex = subcategories.value.findIndex(
							(pred) => pred.parent == categories.value[index].name[locale.value]
						);
						// get subcategory index by ID
						const subIndex = subcategories.value[parentIndex].subcategories.findIndex(
							(pred) => pred.id == subcategoryID
						);

						if (subIndex != -1) {
							// set subcategory value
							subcategories.value[parentIndex].subcategories[subIndex].value = true;
							// add to selected subcategories array
							selectedSubcategories.value.push(subcategories.value[parentIndex].subcategories[subIndex]);
						}
					});
				}
			});
		}

		onClickOutside(listRef, () => {
			showList.value = false;
		});

		function getSelectedCategories() {
			return selectedCategories.value.map((category) => {
				return category.name[locale.value];
			});
		}

		return {
			showList,
			listRef,
			locale,
			categories,
			selectedCategories,
			handleCategoryClick,
			subcategories,
			handleSubcategoryClick,
			selectedSubcategories,
			getSelectedCategories,
		};
	},
});
</script>
